import {
  IHpSob,
  IHpSobCategoriesData,
} from 'legacy/lut/classes/models/partner360/ELT/financialData/hpSob/IHpSob'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { PercentInput } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/financialSnapshot/competitors/percentInput/PercentInput'
import { IColumn } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/types'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from '../HpSob.module.scss'
import { YearAndQuarterTh } from '../yearAndQuarterTh/YearAndQuarterTh'

import { getCurrentYearQuarterThShortView } from './getCurrentYearQuarterThShortView'

interface IProps {
  onHpSobChange: (
    index: number,
    cIndex: number,
    changedField: string
  ) => (value: string | number | null) => void
  currentYear: number
  currentFQuarter: number
}

export const getHpSobColumns = ({
  currentYear,
  onHpSobChange,
  currentFQuarter,
}: IProps): IColumn<IHpSob>[] => {
  return [
    {
      title: getFormedEltTranslation('hpSob-table-business-units'),
      field: 'BusinessUnit',
      renderComponent: ({ value }) => (
        <div className={styles.bu}>
          <Translation text={value as string} />
        </div>
      ),
    },
    {
      title: getFormedEltTranslation('hpSob-table-categories'),
      field: 'CategoriesData',
      renderComponent: ({ value }) => {
        const items = value as IHpSobCategoriesData[]
        return (
          <div>
            {items.map((el) => (
              <div key={el.Category} className={styles.category}>
                <Translation span text={el.Category} />
              </div>
            ))}
          </div>
        )
      },
    },
    {
      titleRenderFn: () => <YearAndQuarterTh quarter={'Q1'} />,
      field: 'CategoriesData',
      renderComponent: ({ value, index }) => {
        const items = value as IHpSobCategoriesData[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <PercentInput
                max={100}
                min={-100}
                withoutSign
                key={cIndex}
                className={styles.input}
                value={el.SobActuals22Q1 ? el.SobActuals22Q1.toString() : undefined}
                onChange={onHpSobChange(index, cIndex, 'SobActuals22Q1')}
              />
            ))}
          </div>
        )
      },
    },
    {
      titleRenderFn: () => <YearAndQuarterTh quarter={'Q2'} />,
      field: 'CategoriesData',
      renderComponent: ({ value, index }) => {
        const items = value as IHpSobCategoriesData[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <PercentInput
                max={100}
                min={-100}
                withoutSign
                key={cIndex}
                className={styles.input}
                value={el.SobActuals22Q2 ? el.SobActuals22Q2.toString() : undefined}
                onChange={onHpSobChange(index, cIndex, 'SobActuals22Q2')}
              />
            ))}
          </div>
        )
      },
    },
    {
      titleRenderFn: () => <YearAndQuarterTh quarter={'Q3'} />,
      field: 'CategoriesData',
      renderComponent: ({ value, index }) => {
        const items = value as IHpSobCategoriesData[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <PercentInput
                max={100}
                min={-100}
                withoutSign
                key={cIndex}
                className={styles.input}
                value={el.SobActuals22Q3 ? el.SobActuals22Q3.toString() : undefined}
                onChange={onHpSobChange(index, cIndex, 'SobActuals22Q3')}
              />
            ))}
          </div>
        )
      },
    },
    {
      titleRenderFn: () => <YearAndQuarterTh quarter={'Q4'} />,
      field: 'CategoriesData',
      renderComponent: ({ value, index }) => {
        const items = value as IHpSobCategoriesData[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <PercentInput
                max={100}
                min={-100}
                withoutSign
                key={cIndex}
                className={styles.input}
                value={el.SobActuals22Q4 ? el.SobActuals22Q4.toString() : undefined}
                onChange={onHpSobChange(index, cIndex, 'SobActuals22Q4')}
              />
            ))}
          </div>
        )
      },
    },
    {
      titleRenderFn: () => getCurrentYearQuarterThShortView(1, currentFQuarter, currentYear, true),
      field: 'CategoriesData',
      renderComponent: ({ value, index }) => {
        const items = value as IHpSobCategoriesData[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <PercentInput
                max={100}
                min={-100}
                withoutSign
                key={cIndex}
                className={styles.input}
                value={el.SobActuals23Q1 ? el.SobActuals23Q1.toString() : undefined}
                onChange={onHpSobChange(index, cIndex, 'SobActuals23Q1')}
              />
            ))}
          </div>
        )
      },
    },
    {
      titleRenderFn: () => getCurrentYearQuarterThShortView(2, currentFQuarter, currentYear, true),
      field: 'CategoriesData',
      renderComponent: ({ value, index }) => {
        const items = value as IHpSobCategoriesData[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <PercentInput
                max={100}
                min={-100}
                withoutSign
                key={cIndex}
                className={styles.input}
                value={el.SobActuals23Q2 ? el.SobActuals23Q2.toString() : undefined}
                onChange={onHpSobChange(index, cIndex, 'SobActuals23Q2')}
              />
            ))}
          </div>
        )
      },
    },
    {
      titleRenderFn: () => getCurrentYearQuarterThShortView(3, currentFQuarter, currentYear, true),
      field: 'CategoriesData',
      renderComponent: ({ value, index }) => {
        const items = value as IHpSobCategoriesData[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <PercentInput
                max={100}
                min={-100}
                withoutSign
                key={cIndex}
                className={styles.input}
                value={el.SobActuals23Q3 ? el.SobActuals23Q3.toString() : undefined}
                onChange={onHpSobChange(index, cIndex, 'SobActuals23Q3')}
              />
            ))}
          </div>
        )
      },
    },
    {
      titleRenderFn: () => getCurrentYearQuarterThShortView(4, currentFQuarter, currentYear, true),
      field: 'CategoriesData',
      renderComponent: ({ value, index }) => {
        const items = value as IHpSobCategoriesData[]
        return (
          <div>
            {items.map((el, cIndex) => (
              <PercentInput
                max={100}
                min={-100}
                withoutSign
                key={cIndex}
                className={styles.input}
                value={el.SobActuals23Q4 ? el.SobActuals23Q4.toString() : undefined}
                onChange={onHpSobChange(index, cIndex, 'SobActuals23Q4')}
              />
            ))}
          </div>
        )
      },
    },
  ]
}
